import { useEffect, useState } from 'react';
import React from 'react';
import './recomendados_LB.css';
// import bt_orange from '../../../assets/imgs/nuevo_libro/bt_orange.png'


import fram1 from '../../../assets/img/fram1.png'
import fram2 from '../../../assets/img/fram2.png'
import fram3 from '../../../assets/img/fram3.png'

import estrell from '../../../assets/imgs/detalle_blog/estrell.png'
import { useTranslation } from "react-i18next";

import VideoPopup from '../../popup/videopopup';

const Recomendados_LB = () => {
    const [over, setOver] = useState(true);
    const [over2, setOver2] = useState(false);
    const [over3, setOver3] = useState(false);

    // const img1 = 'https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/Play.svg';

    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("librBlanc");

    const [qty, setQty] = useState(1);
    const initial = 1;
    const max = 3;
    const nextCard = (num) => {
        if ((qty+num) < initial) {
            setQty(initial);            
        }else if ((qty+num) < max) {
            setQty(qty + num);
        } else {
            setQty(max);            
        }
        switch (qty+num) {
            case 1:
                setOver(true);
                setOver2(false);
                setOver3(false);
                break;
            case 2:
                setOver2(true);
                setOver(false);
                setOver3(false);
                break;
            case 3:
                setOver3(true);
                setOver2(false);
                setOver(false);
                break;
        }
    };

    const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);
    const [currentVideoId, setCurrentVideoId] = useState(null);


    const openVideoPopup = (videoId) => {
        setCurrentVideoId(videoId);
        setVideoPopupOpen(true);
      };
    
      const closeVideoPopup = () => {
        setVideoPopupOpen(false);
      };
    return (
        <div class="conte_recom">
            <VideoPopup  isOpen={isVideoPopupOpen} onClose={closeVideoPopup} videoURL={currentVideoId} />

<div class="NL_tit_recomiendan">
                <h1>{(t('header.recomiendan'))}</h1>
            </div>
        <div className='NL_recomendados'>


      

        
            
            <div id='NL_card1'  className={over ? 'active NL_recomendado_card fadeIn animated' : 'NL_recomendado_card'}>
                {/* <div class="NL_recomendado_img" > */}


                    <img class="NL_recomendado_img1" src={fram2}  onClick={() => openVideoPopup('https://www.youtube.com/embed/jlS9EmHZKLM?si=-QyFzRczKirNQeQN')} />

                {/* <img class="NL_recomendado_img1" src='https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/reviews/poster-review-1.jpg' /> */}
                {/* </div> */}
                <div class=" NL_recomendados_txt">
                    {/* <div> */}
                    <h3> Mario Vargas Llosa</h3>

                    {/* </div> */}
                    {/* <h4>Presidenta del Consejo Directivo de FAZ</h4> */}
                    <p class="dedica">{(t('header.dedica1'))} <br />
                        {(t('header.dedica12'))}
                    </p>
                    <div class="estrellas">
                        <div> <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} /></div>
                    </div>
                    <p> {(t('header.opini1'))}
                        {/* <p>Creador del prólogo del libro de Ricardo Salinas “Ideas sobre la libertad que cambian al mundo”. */}
                    </p>
                </div>
            </div>
            <div id='NL_card2' className={over2 ? 'active NL_recomendado_card fadeIn animated' : 'NL_recomendado_card'}>
                {/* <div class="NL_recomendado_img"> */}


                    <img class="NL_recomendado_img1" src={fram1}  onClick={() => openVideoPopup('https://www.youtube.com/embed/2hQyaequlR8?si=VpZ7jS9MYrprnQEX')} />

                {/* <img class="NL_recomendado_img1" src='https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/reviews/poster-review-2.jpg' /> */}
                {/* </div> */}
                <div class="NL_recomendados_txt">
                    <h3>Leonardo Curzio</h3>
                    <p class="dedica">{(t('header.dedica2'))}
                    </p>
                    <div class="estrellas">
                        <div> <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} /></div>
                    </div>
                    <p>{(t('header.opini2'))}</p>
                    {/* <p>Escribió el prólogo del libro Ricardo Salinas “Ideas sobre la libertad que cambian al mundo”</p> */}
                </div>
            </div>
            <div id='NL_card3' className={over3 ? 'active NL_recomendado_card fadeIn animated' : 'NL_recomendado_card'}>
                {/* <div class="NL_recomendado_img"> */}


                    <img class="NL_recomendado_img1" src={fram3} onClick={() => openVideoPopup('https://www.youtube.com/embed/mJNMPKlztYY?si=m1ort_FTkrTitJqv')}/>
                {/* <img class="NL_recomendado_img1" src='https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/reviews/poster-review-3.jpg' /> */}
                {/* </div> */}
                <div class="NL_recomendados_txt">
                    <h3>Axel Kaiser</h3>
                    <p class="dedica">{(t('header.dedica3'))} <br />
                       
                    </p>
                    <div class="estrellas">
                        <div> <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} />
                            <img class="estre" src={estrell} /></div>
                    </div>     <p>
                        {/* Escritor de la introducción al libro de Ricardo Salinas “ideas sobre la libertad que cambian al mundo”</p> */}
                        {(t('header.opini3'))}</p>
                </div>
            </div>
            <div class="NL_coment_arrows_movil">
                <a onClick={() => nextCard(-1)}>
                    <img class="NL_coment_show_arrowL_movil" src='/assets/imgs/detalle_blog/arrow.png'/>
                </a>
                <a onClick={() => nextCard(+1)}>
                    <img class="NL_coment_show_arrowL_movil" src='/assets/imgs/detalle_blog/arrow.png'/>
                </a>
            </div>
        </div>
        </div>
    )
}

export default Recomendados_LB
